import { connect } from "react-redux";

import Willkommen from "./Willkommen";

export default connect(state => ({
	ablauf_version: state.ablauf.master.version
}))(Willkommen);
